var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Copyright (C) Quantron Systems LLC.
//  All Rights Reserved.
//
//  This file is part of the private project.
//  For conditions of distribution and use,
//  please contact sales@quantron-systems.com
//
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import _ from 'lodash';
import { useEffect, useRef, useState } from 'react';
import { FaLongArrowAltLeft } from 'react-icons/fa';
import withConfirmation from '../hoc/withConfirmation';
import { stationAPI } from '../api/stationAPI';
import { Row, Col, Form, ButtonToolbar, Button } from './common/bootstrap';
import Spinner from './common/Spinner';
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function BackgroundCard(_a) {
    var _this = this;
    var photo = _a.photo, doConfirmation = _a.doConfirmation, stationId = _a.stationId, handleClose = _a.handleClose;
    var previewBody = {
        id: stationId, category: photo.category, side: photo.side, preview: false
    };
    var _b = __read(useState(false), 2), applyVisible = _b[0], setApplyVisible = _b[1];
    var _c = __read(stationAPI.useSaveBackgroundMutation(), 2), saveBackground = _c[0], isLoading = _c[1].isLoading;
    var _d = __read(stationAPI.useDeleteBackgroundMutation(), 1), deleteSelectel = _d[0];
    var _e = __read(stationAPI.useApplyBackgroundMutation(), 2), applyBackground = _e[0], apply = _e[1];
    var preview = stationAPI.useGetPreviewQuery(previewBody);
    var imageRef = useRef(null);
    var _f = __read(useState({ x: 0, y: 0 }), 2), left = _f[0], setLeft = _f[1];
    var _g = __read(useState({ x: 0, y: 0 }), 2), right = _g[0], setRight = _g[1];
    var _h = __read(useState(0), 2), centerX = _h[0], setCenterX = _h[1];
    var _j = __read(useState(''), 2), previewUrl = _j[0], setPreviewUrl = _j[1];
    var _k = __read(useState(''), 2), file = _k[0], setFile = _k[1];
    var splitCoordinates = function (coordinate, index) {
        if (coordinate) {
            return +coordinate.split(',')[index].trim();
        }
        return 0;
    };
    var leftPointStyle = {
        left: "".concat(left.x, "%"),
        top: "".concat(left.y, "%")
    };
    var rightPointStyle = {
        left: "".concat(right.x, "%"),
        top: "".concat(right.y, "%")
    };
    var handleCoordinates = function (e) {
        if (imageRef.current !== null) {
            var imageWidth = imageRef.current.offsetWidth;
            var imageHeight = imageRef.current.offsetHeight;
            var x = e.nativeEvent.offsetX;
            var y = e.nativeEvent.offsetY;
            if (centerX > x) {
                setLeft({
                    x: _.round(x / (imageWidth / 100)),
                    y: _.round(y / (imageHeight / 100))
                });
            }
            else {
                setRight({
                    x: _.round(x / (imageWidth / 100)),
                    y: _.round(y / (imageHeight / 100))
                });
            }
        }
    };
    var getPixelsCoordinates = function () {
        if (imageRef.current !== null) {
            var imageWidth = imageRef.current.naturalWidth;
            var imageHeight = imageRef.current.naturalHeight;
            var leftXPixels = _.round((imageWidth * left.x) / 100);
            var leftYPixels = _.round((imageHeight * left.y) / 100);
            var rightXPixels = _.round((imageWidth * right.x) / 100);
            var rightYPixels = _.round((imageHeight * right.y) / 100);
            return {
                leftXPixels: leftXPixels,
                leftYPixels: leftYPixels,
                rightXPixels: rightXPixels,
                rightYPixels: rightYPixels
            };
        }
        return {};
    };
    var handleDeleteSelectel = function () {
        var selectelFileId = photo.selectelFileId;
        doConfirmation('Вы уверены?', function () { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, deleteSelectel({ selectelFileId: selectelFileId, stationId: stationId })];
                    case 1:
                        _a.sent();
                        handleClose();
                        return [2 /*return*/];
                }
            });
        }); });
    };
    var handleApplyPreview = function () { return __awaiter(_this, void 0, void 0, function () {
        var side, category, _a, leftXPixels, leftYPixels, rightXPixels, rightYPixels, formData;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    side = photo.side, category = photo.category;
                    _a = getPixelsCoordinates(), leftXPixels = _a.leftXPixels, leftYPixels = _a.leftYPixels, rightXPixels = _a.rightXPixels, rightYPixels = _a.rightYPixels;
                    formData = new FormData();
                    formData.append('backgroundImage', file);
                    formData.append('side', side);
                    formData.append('BackgroundImageLeftWheelPoint', "".concat(leftXPixels, ", ").concat(leftYPixels));
                    formData.append('BackgroundImageRightWheelPoint', "".concat(rightXPixels, ", ").concat(rightYPixels));
                    formData.append('stationId', stationId);
                    formData.append('category', category);
                    return [4 /*yield*/, applyBackground(formData)];
                case 1:
                    _b.sent();
                    setApplyVisible(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var onSave = function () { return __awaiter(_this, void 0, void 0, function () {
        var selectelFileId, side, category, formData, _a, leftXPixels, leftYPixels, rightXPixels, rightYPixels;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    selectelFileId = photo.selectelFileId, side = photo.side, category = photo.category;
                    formData = new FormData();
                    if (!(imageRef.current !== null)) return [3 /*break*/, 2];
                    _a = getPixelsCoordinates(), leftXPixels = _a.leftXPixels, leftYPixels = _a.leftYPixels, rightXPixels = _a.rightXPixels, rightYPixels = _a.rightYPixels;
                    formData.append('selectelFileId', selectelFileId);
                    formData.append('file', file);
                    formData.append('left', "".concat(leftXPixels, ", ").concat(leftYPixels));
                    formData.append('right', "".concat(rightXPixels, ", ").concat(rightYPixels));
                    formData.append('side', side);
                    formData.append('category', category);
                    return [4 /*yield*/, saveBackground({
                            stationId: stationId,
                            body: formData
                        })];
                case 1:
                    _b.sent();
                    handleClose();
                    _b.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        if (preview === null || preview === void 0 ? void 0 : preview.data) {
            setPreviewUrl(URL.createObjectURL(preview.data));
            setFile(preview.data);
        }
    }, [preview]);
    var setInitialCoordinates = function () {
        if (imageRef.current !== null) {
            var imageWidth = imageRef.current.naturalWidth;
            var imageHeight = imageRef.current.naturalHeight;
            var leftX = splitCoordinates(photo.left, 0);
            var leftY = splitCoordinates(photo.left, 1);
            var rightX = splitCoordinates(photo.right, 0);
            var rightY = splitCoordinates(photo.right, 1);
            var leftXPercent = _.round(leftX / (imageWidth / 100));
            var leftYPercent = _.round(leftY / (imageHeight / 100));
            var rightXPercent = _.round(rightX / (imageWidth / 100));
            var rightYPercent = _.round(rightY / (imageHeight / 100));
            setLeft({
                x: leftXPercent > 100 ? 100 : leftXPercent,
                y: leftYPercent > 100 ? 100 : leftYPercent
            });
            setRight({
                x: rightXPercent > 100 ? 100 : rightXPercent,
                y: rightYPercent > 100 ? 100 : rightYPercent
            });
            setCenterX(imageRef.current.offsetWidth / 2);
        }
    };
    return (_jsxs("div", __assign({ className: 'card p-3' }, { children: [apply.data && applyVisible && _jsxs("div", { children: [_jsx(Button, __assign({ onClick: function () { return setApplyVisible(false); }, className: 'mb-2', variant: 'success' }, { children: _jsx(FaLongArrowAltLeft, { fill: 'white', size: 26 }, void 0) }), void 0), _jsx(ApplyImage, { file: apply.data }, void 0)] }, void 0), _jsx("div", __assign({ onClick: handleCoordinates, className: "position-relative o-hidden ".concat(applyVisible ? 'd-none' : '') }, { children: preview.isLoading ? _jsx("div", __assign({ className: 'station__background-img' }, { children: _jsx(Spinner, {}, void 0) }), void 0)
                    : _jsxs(_Fragment, { children: [_jsx("img", { src: previewUrl, ref: imageRef, onLoad: setInitialCoordinates, className: 'img-fluid', alt: 'image' }, void 0), _jsx("span", { className: 'background-image__point', style: leftPointStyle }, void 0), _jsx("span", { className: 'background-image__point', style: rightPointStyle }, void 0)] }, void 0) }), void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsxs("div", { children: ["ID: ", photo.selectelFileId] }, void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsxs(Row, { children: [_jsx(Col, __assign({ md: 6 }, { children: _jsxs("div", { children: ["\u0412\u0438\u0434: ", photo.side === 'Front' ? 'Спереди' : 'Сзади'] }, void 0) }), void 0), _jsx(Col, __assign({ md: 6 }, { children: _jsxs("div", { children: ["\u041A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u044F: ", photo.category] }, void 0) }), void 0)] }, void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsx("div", __assign({ className: 'mb-2' }, { children: "\u041A\u043E\u043E\u0440\u0434\u0438\u043D\u0430\u0442\u044B:" }), void 0), _jsxs(Row, { children: [_jsx(Col, __assign({ md: 12 }, { children: _jsxs(Row, __assign({ className: 'align-items-center mb-2' }, { children: [_jsx(Col, __assign({ md: 6 }, { children: _jsx("span", { children: "\u041B\u0435\u0432\u0430\u044F \u0442\u043E\u0447\u043A\u0430: (%)" }, void 0) }), void 0), _jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, __assign({ className: 'align-items-center' }, { children: [_jsx(Col, __assign({ md: 4 }, { children: _jsx("span", { children: "x:" }, void 0) }), void 0), _jsx(Col, __assign({ md: 8 }, { children: _jsx(Form.Control, { type: 'number', value: left.x, onChange: function (e) { return setLeft({ y: left.y, x: +e.target.value }); } }, void 0) }), void 0)] }), void 0) }), void 0), _jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, __assign({ className: 'align-items-center' }, { children: [_jsx(Col, __assign({ md: 4 }, { children: _jsx("span", { children: "y:" }, void 0) }), void 0), _jsx(Col, __assign({ md: 8 }, { children: _jsx(Form.Control, { type: 'number', value: left.y, onChange: function (e) { return setLeft({ x: left.x, y: +e.target.value }); } }, void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0)] }), void 0) }), void 0), _jsx(Col, __assign({ md: 12 }, { children: _jsxs(Row, __assign({ className: 'align-items-center' }, { children: [_jsx(Col, __assign({ md: 6 }, { children: _jsx("span", { children: "\u041F\u0440\u0430\u0432\u0430\u044F \u0442\u043E\u0447\u043A\u0430: (%)" }, void 0) }), void 0), _jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, { children: [_jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, __assign({ className: 'align-items-center' }, { children: [_jsx(Col, __assign({ md: 4 }, { children: _jsx("span", { children: "x:" }, void 0) }), void 0), _jsx(Col, __assign({ md: 8 }, { children: _jsx(Form.Control, { type: 'number', value: right.x, onChange: function (e) { return setRight({ y: right.y, x: +e.target.value }); } }, void 0) }), void 0)] }), void 0) }), void 0), _jsx(Col, __assign({ md: 6 }, { children: _jsxs(Row, __assign({ className: 'align-items-center' }, { children: [_jsx(Col, __assign({ md: 4 }, { children: _jsx("span", { children: "y:" }, void 0) }), void 0), _jsx(Col, __assign({ md: 8 }, { children: _jsx(Form.Control, { type: 'number', value: right.y, onChange: function (e) { return setRight({ x: right.x, y: +e.target.value }); } }, void 0) }), void 0)] }), void 0) }), void 0)] }, void 0) }), void 0)] }), void 0) }), void 0)] }, void 0), _jsx("hr", { className: 'sidebar-divider d-none d-md-block' }, void 0), _jsxs(ButtonToolbar, __assign({ className: 'justify-content-end' }, { children: [_jsx(Button, __assign({ variant: 'danger', onClick: handleDeleteSelectel }, { children: "\u0423\u0434\u0430\u043B\u0438\u0442\u044C" }), void 0), _jsx(Button, __assign({ variant: 'info', className: 'ml-2', onClick: handleApplyPreview }, { children: !apply.isLoading ? 'Показать превью'
                            : _jsxs("span", { children: ["\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u044C \u043F\u0440\u0435\u0432\u044C\u044E ", _jsx(Spinner, { sm: true }, void 0)] }, void 0) }), void 0), _jsx(Button, __assign({ className: 'ml-2', onClick: onSave }, { children: !isLoading ? 'Сохранить'
                            : _jsxs("span", { children: ["\u0421\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C ", _jsx(Spinner, { sm: true }, void 0)] }, void 0) }), void 0)] }), void 0)] }), void 0));
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
function ApplyImage(_a) {
    var file = _a.file;
    var imageUrl = file ? URL.createObjectURL(file) : '';
    return (_jsx("div", { children: _jsx("img", { src: imageUrl, alt: 'image', className: 'img-fluid' }, void 0) }, void 0));
}
////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
export default withConfirmation(BackgroundCard);
